import ProgramDetail from "pages/therapists/patient/programDetail";

const PatientProgramDetail = () => {
    
    return (
        <ProgramDetail isPatientSite/>
    )
}

export default PatientProgramDetail